import { formatAxis, metricUnit } from './metric'

// echarts 默认的标签字体，量宽度得用同一套
const LABEL_FONT = '12px sans-serif'
// 标签和轴线之间的间隙
const LABEL_GAP = 8
// 标签左边留的白（10，和原来的 grid.left 一样），外加一个数字的余量 ——
const LEFT_PAD = 17

let ctx = null

// 量一段文字的宽度。按字符数估会差好几个 px（日期里的「-」比数字窄不少，
// 「$」也不是三个等宽字符），估少了标签被画布裁掉、估多了白留一条，
// 所以老老实实用 canvas 量。canvas 只建一个，反复用
export function textWidth(text) {
  if (!ctx) {
    ctx = document.createElement('canvas').getContext('2d')
    ctx.font = LABEL_FONT
  }
  const str = (text === undefined || text === null) ? '' : String(text)
  return Math.ceil(ctx.measureText(str).width)
}

function listPeak(list) {
  if (!Array.isArray(list)) return 0
  let max = 0
  list.forEach(val => {
    const num = Math.abs(Number(val) || 0)
    if (num > max) max = num
  })
  return max
}

// 一张趋势图要给纵轴留多宽（含标签、间隙和左边留白）。data 是 curve 的原样返回。
// 顶部刻度的标签最宽，而刻度是 echarts 按数据最大值定的，所以拿最大值的格式化结果去量。
// 被点掉的曲线其实不参与量程，这里也算进去 —— 宁可多留一点，少留会裁字
export function yAxisWidth(indicator, data) {
  const groups = (data && Array.isArray(data.groups)) ? data.groups : []
  let peak = 0
  groups.forEach(group => {
    peak = Math.max(peak, listPeak(group.data), listPeak(group.cyc_data))
  })
  // 全 0 的图没有量程可依，echarts 自己给一个：计数类我们锁成了 0~5，
  // 金额和比率会切成 0~1、步长 0.2。顶部刻度都不是 0，按 0 去估会少留一截
  // （金额那条真正最宽的标签是「$0.8」），所以拿这两个值当下限
  if (!peak) peak = metricUnit(indicator) === 'count' ? 5 : 0.8
  return textWidth(formatAxis(indicator, peak)) + LABEL_GAP + LEFT_PAD
}
